import type { Achievement } from '../types/resume';

export const featuredAchievement = {
  title: 'Led the technology transformation of a multi-company pharmaceutical group',
  organization: 'Megalabs Chile',
  period: '2017 – 2022',
  description:
    'As Chief Information Officer, led innovation, optimization and digital transformation across Megalabs Chile, Garden House Farmacéutica, Leterago Chile and Garden House USA, connecting technology strategy with business priorities.',
  outcomes: [
    'ERP migrated to Microsoft Dynamics 365 cloud, with change management',
    'Cloud BI platform developed on Azure',
    'Control tower built for logistics operations',
    'CRM implemented and integrated with eCommerce for GH USA',
  ],
};

export const metricAchievements: Achievement[] = [
  {
    title: 'Doubled the customer base in Peru in one year',
    organization: 'Sun Microsystems',
    period: '2003 – 2004',
    description: 'As Business Director, implemented a new sales strategy for Peru based on a country distributor model.',
    metric: { value: '2×', label: 'Customer base in one year' },
  },
  {
    title: 'Achieved sales goals with 97% revenue linearity',
    organization: 'Sun Microsystems',
    period: '2001 – 2002',
    description: 'Led regional sales in the Andes Region through a system-integrator channel and new wholesale relationships.',
    metric: { value: '97%', label: 'Revenue linearity' },
  },
];

export const achievements: Achievement[] = [
  {
    title: 'Rose from Board Member to Chairman of the Board',
    organization: 'Provectis',
    period: '2023 – 2025',
    description:
      'Provided governance and strategic oversight to an IT services organization in infrastructure monitoring, cybersecurity, help desk and professional services.',
  },
  {
    title: 'Led LATAM operations across five countries',
    organization: 'COSMO CONSULT',
    period: '2022 – 2023',
    description:
      'Led operations in Mexico, Colombia, Ecuador, Peru and Chile, with initiatives in Microsoft Dynamics, Power BI and CRM.',
  },
  {
    title: 'Managed a portfolio of leading global brands',
    organization: 'Intel Corporation',
    period: '2009 – 2016',
    description:
      'Managed a portfolio including HP, Samsung, Acer, Lenovo, Toshiba, Sony and Asus, and introduced new products through leading retailers in Chile.',
  },
  {
    title: 'Built growth plans for Neosecure and Provectis',
    organization: 'Momentum Consulting',
    period: '2004 – 2005',
    description:
      'Covered market strategy for Chile and Latin America, product and services models, and financial planning for projected operations.',
  },
  {
    title: 'Repositioned the corporate brand in the Andes Region',
    organization: 'Sun Microsystems',
    period: '1999 – 2000',
    description: 'Developed a new approach to brand positioning through executive events, press management and channel activities.',
  },
  {
    title: 'Opened the Peruvian market',
    organization: 'Synapsis',
    period: '1995 – 1996',
    description:
      'Won two major contracts with electricity companies in Lima, establishing the base for the Synapsis Peru subsidiary.',
  },
  {
    title: 'Developed the market for Xnear Workflow',
    organization: 'Synapsis',
    period: '1993 – 1994',
    description: 'Owned pricing, marketing, licensing, launches and regional channel organization for the product.',
  },
];
